import { INewsItem, NewsService } from "../services/index";

class NewsPanelController {
    private news: INewsItem[];

    constructor( 
        private NewsService: NewsService,
        private $state: ng.ui.IStateService,
        private $scope: ng.IScope) {
        'ngInject';       
    }

    $onInit = () => {
    }

    setRead(id) {
        this.NewsService.customPut(id + '/read', {}).then(result => {
           this.NewsService.getList().then(result => {
                this.news = result.value;
           })
        });
    }
}

export const newsPanelComponent = {
    bindings: {
        news: '<'
    },
    controller: NewsPanelController,
    template: require('./newsPanel.html')
};



// WEBPACK FOOTER //
// ./src/app/main/newsPanel.component.ts